"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isEqual(a, b) {
    return a === b;
}
exports.config = {
    production: isEqual('false', 'true'),
    hmr: isEqual('false', 'true'),
    services: {
        data: {
            endpoint: 'wss://data.buymyplace.com.au/v1/graphql',
        },
        googleMaps: {
            key: '***'
        },
        analytics: {
            segment: {
                enabled: isEqual('false', 'true'),
                writeKey: '***',
            },
        },
        sentry: {
            sentryDsnVendor: '***',
        },
    },
    application: {
        branch: 'local',
        buildDate: 'Tue, 12 Mar 2024 09:57:53 GMT',
        buildNumber: 'undefined',
        version: '0.0.10',
        gitHead: 'undefined'
    }
};
